import { ApolloLink } from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'
import errorHandler from '@marketplace/plugins/apollo-error-handler.js'
import Cookies from 'js-cookie'

// Set the current revision to local storage per request so we can check later if the user has the latest version of the app running.
// See the middleware version-refresh.js for more details.
const afterwareLink = new ApolloLink((operation, forward) => {
    return forward(operation).map((response) => {
        const context = operation.getContext()
        const revisionHeader = context.response.headers.get('x-revision')

        localStorage.setItem('oc-revision', revisionHeader)

        return response
    })
})

export default (context) => {
    const csrfToken = Cookies.get('XSRF-TOKEN')
    const { appUrl } = context.$config

    let httpEndpoint = `${appUrl}/v2/graphql`
    const locale = context.i18n.locale

    if (locale !== 'en') {
        httpEndpoint = `${appUrl}/${locale}/v2/graphql`
    }

    const config = {
        link: ApolloLink.from([
            onError((error) => errorHandler(error, context)),
            afterwareLink,
        ]),
        httpEndpoint,

        httpLinkOptions: {
            credentials: 'include',
            headers: {
                accept: 'application/json',
                'content-type': 'application/json',
                'X-CSRF-Token': csrfToken || '',
            },
        },

        localSchemaFile: '../../../../graphql-web-schema.graphql',
    }

    return config
}
